import {ViewPopupLanguage} from '../../../shared/scripts/ui_popup/ViewPopupLanguage'
import {setElementInnerText, setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {createTooltipIn} from '../../../shared/scripts/ui_utils/TooltipUtils'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'

export class UILanguageController {
    private readonly languageButtons: NodeListOf<HTMLDivElement>

    constructor() {
        this.languageButtons = document.querySelectorAll('.language-button')
        this.setupLanguageButtons()
    }

    private setupLanguageButtons() {
        this.languageButtons.forEach((languageButton) => {
            setElementOnClick(languageButton, () => {
                new ViewPopupLanguage()
            })
            createTooltipIn(languageButton, {key: 'strings:homePage.footer.changeLanguageButtonTooltip'}, 'top', undefined, 'small')
            const languageTextDiv = languageButton.querySelector('div')
            if(!languageTextDiv) return
            setElementInnerText(languageTextDiv, {key: 'strings:colonistCommon.utils.#buffer', options: {value: UIUtilsEjsVariables.language}})
        })
    }
}

